<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Veri Türü</label>
            <v-validator :errors="errors" parameter="CompanySystemConstantDataTypeId" :watch="type">
             <v-select-list :disabled="editing" placeholder="Veri Türü" v-model="type" label="VisibleName" :options="types"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Değer</label>
            <v-validator :errors="errors" parameter="Value" :watch="value.Value">
             <input class="form-control" type="text" placeholder="Değer" v-model="value.Value"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import VValidator from '@/components/VValidator.vue';
export default {
    components:{
        VValidator
    },
    props:{
        value:Object,
        errors:Object,
        editing:Boolean,
    },
    mounted(){
        this.getDataTypes();
    },
    data(){
        return {
            types:[],
        }
    },
    methods:{
        getDataTypes(){
            SystemDataApi.DataType().then(res=>{
                this.types = res.data.Data
            })
        }
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.CompanySystemConstantDataTypeId)
            },
            set:function(value){
                this.value.CompanySystemConstantDataTypeId = value?.Id || null
            }
        }
    }
}
</script>

<style lang="scss">
</style>